// =============================================================================
//  LoginPageStaff — page login dédiée staff Cinqo (Auth V2, audit 2026-05-03)
//
//  Accessible via /admin/login. Google OAuth uniquement (Workspace @cinqo.fr).
//  Pas d'email+password ici (les staff utilisent Workspace + MFA).
//
//  Sécurité :
//   - hd: 'cinqo.fr' hint Google → picker filtre les comptes Workspace
//   - Idéalement (à confirmer Mehdi) : Google OAuth client en "Workspace Internal"
//     côté Google Cloud Console → rejet automatique des emails non-Workspace
//   - Defense in depth (ce code) : check post-OAuth dans auth.tsx — si email
//     ne finit pas par @cinqo.fr → signOut + toast (à wirer)
// =============================================================================

import { useState } from 'react'
import { brandPalette } from '@cinqo/brand'
import { supabase } from '../lib/supabase'

export default function LoginPageStaff() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const signInWithGoogle = async () => {
    setLoading(true)
    setError(null)
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin,
          queryParams: { hd: 'cinqo.fr' },
        },
      })
      if (error) setError('Erreur connexion Google : ' + error.message)
    } catch (e) {
      setError('Erreur inattendue : ' + (e as Error).message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-900 to-violet-700 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-2xl text-white text-[24px] font-bold mb-4"
            style={{ backgroundColor: brandPalette.primary }}
          >
            C
          </div>
          <h1 className="text-[24px] font-bold text-white">Cinqo Staff</h1>
          <p className="text-[14px] text-white/60 mt-1">Connexion réservée à l'équipe Cinqo (@cinqo.fr)</p>
        </div>

        <div className="bg-white rounded-xl border border-neutral-100 p-6 shadow-sm">
          {error && (
            <div className="mb-4 p-3 rounded-lg bg-error-bg text-error text-caption">
              {error}
            </div>
          )}
          <button
            onClick={signInWithGoogle}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-lg border border-neutral-200 bg-white hover:bg-neutral-50 transition-colors text-[14px] font-medium text-neutral-700 cursor-pointer disabled:opacity-50"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
            </svg>
            {loading ? 'Connexion en cours...' : 'Continuer avec Google Workspace'}
          </button>

          <div className="mt-6 text-center text-caption text-ink-muted">
            Pas membre de l'équipe Cinqo ?{' '}
            <a href="/login" className="text-violet-500 hover:underline">Connexion client/partenaire</a>
          </div>
        </div>
      </div>
    </div>
  )
}
